import React from 'react';
import fr from 'facet-rest';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const BackButtonPicker = () => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  const onClick = () => {
    const insightsLink = pageContentResource
      .relationship(fr.relationships.smartScenarioInsights.name)
      .link('related');

    loadPageContentLink(insightsLink);
  };

  return (
    <IconButton
      color="black"
      component={null}
      icon={ChevronLeftIcon}
      size="large"
      title="Go back"
      test={'pwa-back-button'}
      onClick={onClick}
    />
  );
};

export default BackButtonPicker;
